import api from "./api";

class PianoDiFatturazioneManager {
    pianiDiFatturazione(config?: any) {
        return api.get(`/piano_di_fatturazione/`, config)
    }

    pianoDiFatturazione(pdf_id: number | string, config?: any) {
        return api.get(`/piano_di_fatturazione/${pdf_id}`, config)
    }

    retrieve = this.pianoDiFatturazione
    list = this.pianiDiFatturazione
    paginatedList = this.pianiDiFatturazione
}

const pianoDiFatturazioneManager = new PianoDiFatturazioneManager()

export default pianoDiFatturazioneManager

